/* Hallows Night — regalo automático.
   Si el carrito tiene el producto que da derecho al regalo, el regalo se añade
   solo con precio 0 y en la misma cantidad. Si el producto desaparece del
   carrito, el regalo desaparece con él. Sin apps y sin tocar el checkout. */
(function () {
  'use strict';

  var node = document.getElementById('hn-gift-config');
  if (!node) return;

  var cfg;
  try {
    cfg = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.giftId || !cfg.triggerIds || !cfg.triggerIds.length) return;

  var triggers = cfg.triggerIds.map(Number);
  var giftId = Number(cfg.giftId);
  var syncing = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json();
    });
  }

  /* Vuelve a pintar el carrito con los mecanismos propios del tema. */
  function repaint() {
    var host =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items');

    if (host && typeof host.getSectionsToRender === 'function' && typeof host.renderContents === 'function') {
      var ids = host.getSectionsToRender().map(function (s) {
        return s.id;
      });
      return post('/cart/update.js', {
        updates: {},
        sections: ids,
        sections_url: window.location.pathname
      })
        .then(function (state) {
          try {
            host.renderContents(state);
          } catch (e) {
            /* si el tema cambia, al menos el contador se actualiza abajo */
          }
          return state;
        })
        .then(updateBubble);
    }

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(updateBubble);
  }

  function updateBubble(cart) {
    if (!cart || typeof cart.item_count !== 'number') return cart;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    return cart;
  }

  function sync() {
    if (syncing) return Promise.resolve();
    syncing = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var wanted = 0;
        var giftLine = null;

        cart.items.forEach(function (item) {
          if (triggers.indexOf(item.variant_id) !== -1) wanted += item.quantity;
          if (item.variant_id === giftId) giftLine = item;
        });

        // Sin producto que lo dispare: fuera el regalo.
        if (wanted === 0) {
          if (!giftLine) return null;
          return post('/cart/change.js', { id: giftLine.key, quantity: 0 });
        }

        // Ya está y con la cantidad correcta: nada que hacer.
        if (giftLine && giftLine.quantity === wanted) return null;

        if (giftLine) {
          return post('/cart/change.js', { id: giftLine.key, quantity: wanted });
        }

        var payload = { id: giftId, quantity: wanted };
        if (cfg.label) payload.properties = { 'Free gift': cfg.label };
        return post('/cart/add.js', payload);
      })
      .then(function (changed) {
        if (changed) return repaint();
        return null;
      })
      .catch(function () {
        /* Si algo falla, el carrito se queda como está: nunca bloqueamos la compra. */
      })
      .then(function () {
        syncing = false;
      });
  }

  function start() {
    sync();

    // Dawn avisa de cada cambio del carrito por su propio bus de eventos.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.quantityUpdate].forEach(function (evt) {
        if (!evt) return;
        subscribe(evt, function () {
          window.setTimeout(sync, 150);
        });
      });
    }

    // Red de seguridad para cambios que no pasan por el bus de Dawn
    // (por ejemplo, otra pestaña o una app): se comprueba tras cada cambio
    // de carrito detectado en el contador.
    document.addEventListener('click', function (event) {
      if (event.target.closest('cart-drawer, cart-items, .cart__ctas, quantity-input, cart-remove-button')) {
        window.setTimeout(sync, 700);
      }
    });

    // Red de seguridad: al volver a la pestaña, recomprobamos.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
